export const contractDeployStages = [
    {
        name: 'read',
        title: 'Reading contract',
        content: 'Contract being read from secure storage',
    },
    {
        name: 'sign',
        title: 'Signing contract',
        content: 'Please sign using Metamask',
    },
    {
        name: 'deploy',
        title: 'Deploying Contract',
        content: 'Contract being deployed to the blockchain',
    },
]